import React, { useState } from 'react';
import {
  Box, Button,
  ButtonGroup,
  Card,
  CardContent,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Grid,
  TextField
} from '@material-ui/core';

const MainAuthorsSearch = ({loading, handleSubmit, clear}) => {
  const [id, setId] = useState('');
  const [name, setName] = useState('');
  const [onlyOld, setOnlyOld] = useState(false);
  const [onlyFilled, setOnlyFilled] = useState(false);

  const resetForm = () => {
    setId('');
    setName('');
    setOnlyOld(false);
    setOnlyFilled(false);
  };

  return (
    <Card>
      <Box>
        <CardContent>
          <form onSubmit={(e) => {
            e.preventDefault();
            handleSubmit({ id, name, onlyOld, onlyFilled });
          }}>
            <Grid container spacing={1} alignItems='center' justifyContent='space-between'>
              <Grid item xs={4}>
                <TextField
                  label='Pesquisar por ID' name='id' type='text'  size='small' margin='dense' fullWidth
                  value={id}
                  onChange={e => setId(e.target.value)}
                />
              </Grid>
              <Grid item xs={4}>
                <TextField
                  label='Pesquisar por autor' name='name' type='text' size='small' margin='dense' fullWidth
                  value={name}
                  onChange={e => setName(e.target.value)}
                />
              </Grid>
              <Grid item xs={4}></Grid>
              <Grid item xs={4}>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox checked={ onlyOld }
                                onChange={ (e) => setOnlyOld(e.target.checked) } />
                    } label='Mostrar apenas autores com status "Antigo"' />
                </FormGroup>
              </Grid>
              <Grid item xs={4}>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox checked={ onlyFilled }
                                onChange={ (e) => setOnlyFilled(e.target.checked) } />
                    } label='Mostrar apenas autores com status "Preenchido"' />
                </FormGroup>
              </Grid>
              <Grid item xs={4}>
                <ButtonGroup>
                  <Button color='primary' type='submit'
                    disabled={loading}
                    size='large'
                    variant='contained'
                  >
                    Pesquisar
                  </Button>
                  <Button
                    color='primary'
                    variant='outlined'
                    disabled={loading}
                    onClick={() => {
                      resetForm();
                      clear();
                    }}
                  >
                    Limpar
                  </Button>
                </ButtonGroup>
              </Grid>
            </Grid>
          </form>
        </CardContent>
      </Box>
    </Card>
  );
}

export default MainAuthorsSearch;
